<template>  
    <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">        
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ $t('location.UBN') }}: {{ state.ubn }}</h5>
            <p class="mb-0  text-sm">
              {{ state.tags }}
            </p>
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>
    <div id="info" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Location_info') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.UBN') }}:</label>
              <div class="display-field">{{ state.ubn }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.Name') }}:</label>
              <div class="display-field">{{ state.name }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.Location_type') }}:</label>
              <div class="display-field">{{ state.locationType }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.Keeper') }}:</label>
              <div class="display-field">{{ state.keeperFullname }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.Animal_type') }}:</label>
              <div class="display-field">{{ state.animalTypeNames }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static">
              <label class="">{{ $t('location.Max_animal_capicity') }}:</label>
              <div class="display-field">{{ state.maxAnimalCapacity }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="contact" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Contact_address_details') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.E-mail') }}</label>
              <div class="display-field">{{ state.email }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Phone_number') }}</label>
              <div class="display-field">{{ state.phoneNumber }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-8">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Address') }}</label>
              <div class="display-field">{{ state.street }}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.House_number') }}</label>
              <div class="display-field">{{ state.houseNumber }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Zipcode') }}</label>
              <div class="display-field">{{ state.postalCode }}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.City') }}</label>
              <div class="display-field">{{ state.place }}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Country') }}</label>
              <div class="display-field">{{ state.country }}</div>
            </div>
          </div>
        </div>        
      </div>
    </div>
    <!--div id="rvo" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.RVO') }}</h5>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-5">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.E-Verified') }}</label>
              <div class="display-field" style="border-bottom: none;">
                <i class="material-symbols-rounded opacity-10 font-size-18" 
                    :class="state.isRvoVerified ? 'text-success' : 'text-danger'"
                    aria-hidden="true">
                    {{ state.isRvoVerified ? 'thumb_up' : 'thumb_down' }}
                </i>
              </div>              
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verification_date') }}</label>
              <div class="display-field">{{ state.rvoVerificationDate }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verifier') }}</label>
              <div class="display-field">{{ state.rvoVerifier }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verification_method') }}</label>
              <div class="display-field">{{ state.rvoVerificationMethod }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verification_source') }}</label>
              <div class="display-field">{{ state.rvoVerificationSource }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Certificate_number') }}</label>
              <div class="display-field">{{ state.rvoCertificateNumber }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Notes') }}</label>
              <div class="display-field">{{ state.rvoVerificationNotes }}</div>
            </div>
          </div>          
        </div>
      </div>
    </div-->    
    <!--div id="toiler" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('location.Toiler_disease_free') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Disease_free') }}</label>
              <div class="display-field" style="border-bottom: none;">
                <i class="material-symbols-rounded opacity-10 font-size-18" 
                    :class="state.isToilerDiseaseFree ? 'text-success' : 'text-danger'"
                    aria-hidden="true">
                    {{ state.isToilerDiseaseFree ? 'thumb_up' : 'thumb_down' }}
                </i>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Lastcheck_date') }}</label>
              <div class="display-field">{{ state.toilerDiseaseLastCheckDate }}</div>
            </div>
          </div>
      </div>      
      <div class="row mt-3">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Check_method') }}</label>
            <div class="display-field">{{ state.toilerDiseaseCheckMethod }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Uploaded_certificate') }}</label>
            <div class="display-field" style="border-bottom: none;">
              <a v-if="state.toilerCertificateFilePath" :href="state.toilerCertificateFilePath" target="_blank" download class="text-decoration-none">                
                <i class="material-symbols-rounded cursor-pointer text-primary" :title="$t('common.Download')">download</i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Notes') }}</label>
              <div class="display-field">{{ state.toilerNotes }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="scrapie" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Scrapie') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Scrapie_certified') }}</label>
              <div class="display-field" style="border-bottom: none;">
                <i class="material-symbols-rounded opacity-10 font-size-18" 
                    :class="state.hasScrapieCertificate ? 'text-success' : 'text-danger'"
                    aria-hidden="true">
                    {{ state.hasScrapieCertificate ? 'thumb_up' : 'thumb_down' }}
                </i>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Certificate_number') }}</label>
              <div class="display-field">{{ state.scrapieCertificateNumber }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Issued_date') }}</label>
              <div class="display-field">{{ state.scrapieCertificateIssuedDate }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Expiry_date') }}</label>
              <div class="display-field">{{ state.scrapieCertificateExpiryDate }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Issued_by') }}</label>
              <div class="display-field">{{ state.scrapieIssuedBy }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verified_by') }}</label>
              <div class="display-field">{{ state.scrapieVerifiedBy }}</div>
            </div>
          </div>
        </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Uploaded_certificate') }}</label>
            <div class="display-field" style="border-bottom: none;">
              <a v-if="state.scrapieCertificateFilePath" :href="state.scrapieCertificateFilePath" target="_blank" download class="text-decoration-none">                
                <i class="material-symbols-rounded cursor-pointer text-primary" :title="$t('common.Download')">download</i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Certificate_verified') }}</label>
              <div class="display-field" style="border-bottom: none;">
                <i class="material-symbols-rounded opacity-10 font-size-18" 
                    :class="state.isScrapieCertificateVerified ? 'text-success' : 'text-danger'"
                    aria-hidden="true">
                    {{ state.isScrapieCertificateVerified ? 'thumb_up' : 'thumb_down' }}
                </i>
              </div>
            </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Notes') }}</label>
              <div class="display-field">{{ state.scrapieNotes }}</div>
            </div>
          </div>
        </div>
      </div>
    </div-->
    <div id="delete" class="card mt-4" v-show="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteLocation" name="Delete member" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark  d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.location.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteLocation" @click="deleteLocation" name="button">{{ $t('common.Delete_member') }}</button>
      </div>
    </div>
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { reactive } from 'vue'  

  export default {
    name: "MemberOverviewItem",
    setup() {
      const state = reactive ({
          location: [],          
          gets: [],
          id: '',
          ubn: '',
          name: '',
          locationType: '',
          keeperId: '',
          keeperFullname: '',
          maxAnimalCapacity: null,
          animaltypeId: [],
          animalTypeNames: '',

          phoneNumber: '',
          email: '',
          street: '',
          houseNumber: '',
          place: '',
          postalCode: '',
          country: '',	
          latitude: '',
          longitude: '',

          isRvoVerified: false,
          rvoVerificationDate: null,
          rvoVerifier: '',
          rvoVerificationMethod: '',
          rvoVerificationSource: '',
          rvoCertificateNumber: '',
          rvoVerificationNotes: '',

          isToilerDiseaseFree: false,
          toilerDiseaseLastCheckDate: null,
          toilerDiseaseCheckMethod: '',
          toilerNotes: '',
          toilerCertificateFilePath: '',

          hasScrapieCertificate: false,
          scrapieCertificateNumber: '',
          scrapieCertificateIssuedDate: null,
          scrapieCertificateExpiryDate: null,
          scrapieIssuedBy: '',
          scrapieVerifiedBy: '',
          isScrapieCertificateVerified: false,
          scrapieNotes: '',
          scrapieCertificateFilePath: '',
          deleteLocation: false
      })
      return {
          state
      }
    },    
    components: {      
      MaterialSwitch,
    },
    data() {
      return {
        location: [],
        gets: [],
        id: '',
        ubn: '',
        name: '',
        locationType: '',
        keeperId: '',
        keeperFullname: '',
        maxAnimalCapacity: null,
        animalTypeId: [],
        animalTypeNames: '',

        phoneNumber: '',
        email: '',
        street: '',
        houseNumber: '',
        place: '',
        postalCode: '',
        country: '',	
        latitude: '',
        longitude: '',

        isRvoVerified: false,
        rvoVerificationDate: null,
        rvoVerifier: '',
        rvoVerificationMethod: '',
        rvoVerificationSource: '',
        rvoCertificateNumber: '',
        rvoVerificationNotes: '',

        isToilerDiseaseFree: false,
        toilerDiseaseLastCheckDate: null,
        toilerDiseaseCheckMethod: '',
        toilerNotes: '',
        toilerCertificateFilePath: '',

        hasScrapieCertificate: false,
        scrapieCertificateNumber: '',
        scrapieCertificateIssuedDate: null,
        scrapieCertificateExpiryDate: null,
        scrapieIssuedBy: '',
        scrapieVerifiedBy: '',
        isScrapieCertificateVerified: false,
        scrapieNotes: '',
        scrapieCertificateFilePath: ''
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;    
      await this.fetchLocationData(this.$route.params.id);
      //await this.fetchAllTagData();
    },
    methods: {      
      async fetchAllTagData() {
          try {
              const response = await axios.get("MemberTag/getall");
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  this.state.tagsL = result.data;                        
                  // Wait for DOM to update
                  //this.$nextTick(() => {
                      //this.initializeChoices(); // Initialize Choices here
                  //});
              } else {
                this.$showError('errors.Error_fetching_tags');                  
              }
          } catch (e) {                    
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },      
      async fetchLocationData(locationId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Location/${locationId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.location = this.gets.data;

                this.state.id = this.state.location.id;
                this.state.ubn = this.state.location.ubn;
                this.state.name = this.state.location.name || '\u00A0';
                this.state.locationType = this.state.location.locationType;
                this.state.keeperId = this.state.location.keeperId || '\u00A0';
                this.state.keeperFullname = this.state.location.keeperFullname || '\u00A0';
                this.state.maxAnimalCapacity = this.state.location.maxAnimalCapacity || '\u00A0';
                this.state.animaltypeId = this.state.location.animaltypeId;
                this.state.animalTypeNames = this.state.location.animalTypeNames;

                this.state.phoneNumber = this.state.location.phoneNumber || '\u00A0';
                this.state.email = this.state.location.email || '\u00A0';
                this.state.street = this.state.location.street || '\u00A0';
                this.state.houseNumber = this.state.location.houseNumber || '\u00A0';
                this.state.place = this.state.location.place || '\u00A0';
                this.state.postalCode = this.state.location.postalCode || '\u00A0';
                this.state.country = this.state.location.country || '\u00A0';
                this.state.latitude = this.state.location.latitude || '\u00A0';
                this.state.longitude = this.state.location.longitude || '\u00A0';

                this.state.isRvoVerified = this.state.location.isRvoVerified;
                this.state.rvoVerificationDate = this.state.location.rvoVerificationDate || '\u00A0';
                this.state.rvoVerifier = this.state.location.rvoVerifier || '\u00A0';
                this.state.rvoVerificationMethod = this.state.location.rvoVerificationMethod || '\u00A0';
                this.state.rvoVerificationSource = this.state.location.rvoVerificationSource || '\u00A0';
                this.state.rvoCertificateNumber = this.state.location.rvoCertificateNumber || '\u00A0';
                this.state.rvoVerificationNotes = this.state.location.rvoVerificationNotes || '\u00A0';

                this.state.isToilerDiseaseFree = this.state.location.isToilerDiseaseFree;
                this.state.toilerDiseaseLastCheckDate = this.state.location.toilerDiseaseLastCheckDate || '\u00A0';
                this.state.toilerDiseaseCheckMethod = this.state.location.toilerDiseaseCheckMethod || '\u00A0';
                this.state.toilerNotes = this.state.location.toilerNotes || '\u00A0';
                this.state.toilerCertificateFilePath = this.state.location.toilerCertificateFilePath || '\u00A0';

                this.state.hasScrapieCertificate = this.state.location.hasScrapieCertificate;
                this.state.scrapieCertificateNumber = this.state.location.scrapieCertificateNumber || '\u00A0';
                this.state.scrapieCertificateIssuedDate = this.state.location.scrapieCertificateIssuedDate || '\u00A0';
                this.state.scrapieCertificateExpiryDate = this.state.location.scrapieCertificateExpiryDate || '\u00A0';
                this.state.scrapieIssuedBy = this.state.location.scrapieIssuedBy || '\u00A0';
                this.state.scrapieVerifiedBy = this.state.location.scrapieVerifiedBy || '\u00A0';
                this.state.isScrapieCertificateVerified = this.state.location.isScrapieCertificateVerified || '\u00A0';
                this.state.scrapieNotes = this.state.location.scrapieNotes || '\u00A0';
                this.state.scrapieCertificateFilePath = this.state.location.scrapieCertificateFilePath || '\u00A0';


            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      confirmDelete() {
        this.state.deleteLocation = !this.state.deleteLocation;
      },      
      deleteLocation() {
        if (this.state.deleteLocation) {
          this.deleteMember1(this.state.id)
        }
      },                  
      async deleteMember1(id) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("Location/" + id);
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_location_deleted_successfully');
              this.$router.push('/location');
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }         
      }
    }
  };
  </script>  
<style scoped>

.display-field {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #4ca750;
  padding: 2px 0;
  margin-top: 2px;
  background-color: transparent;  
  font-size: 0.875rem;
}

  .card-shadow-all {
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
  }

  .card-body .input-group-static {
    margin-bottom: 5px;
  }

  .card-body .form-control {
    padding: 8px;    
    border-radius: 4px;
  }

  .card-body label {  
    font-size: 0.875rem;
    font-weight: 400;
    color: #7b809a;
  }

  .font-size-18 {
    font-size: 18px !important;
  }
</style>